<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span>{{ $t("accessing-persons.text") }}</span>
      </h2>

      <div class="pcard--title" style="margin-bottom: 0.8rem;">
        <span
          class="add-button hand"
          @click="
            showNewAccessibleAccountPanel = true;
            $forceUpdate();
          "
        >
          {{ $t("accessing-persons.new") }}
          <i class="iconoir-plus font-size-24"></i>
        </span>
      </div>
      <div v-if="showNewAccessibleAccountPanel" class="border border-dark">
        <table class="table align-middle table-nowrap table-hover mb-0">
          <thead>
            <tr>
              <th class="w-40 align" scope="col">{{ $t("common.name") }}</th>

              <th scope="col">{{ $t("file-manager.permissions.read") }}</th>

              <th scope="col">{{ $t("file-manager.permissions.edit") }}</th>
              <th scope="col">{{ $t("file-manager.permissions.delete") }}</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="w-40">
                <organization-member-select :selected="form.account" @onSelect="onMemberSelect" :organization="currentOrganization" :filterFunction="filterFunction" />
              </td>

              <td><b-form-checkbox class="text-center" v-model="form.permissions.read"></b-form-checkbox></td>

              <td><b-form-checkbox class="text-center" v-model="form.permissions.edit"></b-form-checkbox></td>
              <td><b-form-checkbox class="text-center" v-model="form.permissions.delete"></b-form-checkbox></td>
              <td><i @click="save()" class="mdi mdi-check-bold text-success hand font-size-16" v-if="form.account && form.permissions"></i></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive" style="min-height: 340px;">
        <table class="table align-middle  table-hover mb-0">
          <thead>
            <tr>
              <th>{{ $t("common.name") }}</th>
              <th>{{ $t("file-manager.access-reason.text") }}</th>
              <th>{{ $t("file-manager.permissions.read") }}</th>
              <th>{{ $t("file-manager.permissions.edit") }}</th>
              <th>{{ $t("file-manager.permissions.delete") }}</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="pagination">
            <tr v-for="acl in pagination.docs" :key="acl._id">
              <td class="w-40">
                {{ acl.account.name }}
              </td>
              <td>
                <span v-for="accessType in acl.accessTypes" :key="accessType._id">
                  <span class="badge badge-main ml-2">{{ stringifyAccessReason(accessType) }}</span>
                </span>
              </td>
              <td class="text-center"><b-form-checkbox :disabled="acl.editDisabled" @change="onPermissionChange(acl)" v-model="acl.permissions.read"></b-form-checkbox></td>
              <td><b-form-checkbox class="text-center" :disabled="acl.editDisabled" @change="onPermissionChange(acl)" v-model="acl.permissions.edit"></b-form-checkbox></td>
              <td><b-form-checkbox class="text-center" :disabled="acl.editDisabled" @change="onPermissionChange(acl)" v-model="acl.permissions.delete"></b-form-checkbox></td>
              <td>
                <i v-if="acl.editDisabled" @click="deleteById(acl)" class="bx bx-trash text-muted "></i>
                <i v-else @click="deleteById(acl)" class="bx bx-trash text-danger hand"></i>
              </td>
              <td><i v-if="acl.hasUnsavedChanges" @click="update(acl)" class="mdi mdi-check-bold text-success hand font-size-16"></i></td>
            </tr>
          </tbody>
        </table>
        <div v-if="pagination && pagination.docs" class="row">
          <div class="col" v-if="pagination.docs.length > 0">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import OrganizationMemberSelect from "@cc/organization-member-select";
const state = "organizationFileAccessibleAccounts";

export default {
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { _id: "desc" } },
        query: {},
      },
      showNewAccessibleAccountPanel: false,
      form: { account: undefined, permissions: { read: false, edit: false, delete: false } },
    };
  },
  components: { OrganizationMemberSelect },
  validations: {},
  watch: {
    fileRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.fetchFileAccessibleAccounts());
      },
    },
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    selectedFile() {
      return this.$store.getters["fileManager/selectedEntity"];
    },
    accessibleAccounts() {
      return this.$store.getters[`${state}/accessibleAccounts`];
    },
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },

    selectedParentCategory() {
      return this.$store.getters["organizationFileCategory/selectedParentCategory"];
    },
    selectedSubCategory() {
      return this.$store.getters["organizationFileCategory/selectedCategory"];
    },
  },
  async mounted() {},
  methods: {
    async fetchFileAccessibleAccounts() {
      if (!this.selectedFile) {
        return;
      }
      await this.$store.dispatch(`${state}/accessibleAccountsByFileId`, { fileId: this.selectedFile._id, pagination: this.request });
    },
    onPermissionChange(acl) {
      acl.hasUnsavedChanges = true;
      this.$forceUpdate();
    },
    stringifyAccessReason(reason) {
      if (!reason) {
        return "";
      }
      return this.$t(`file-manager.access-reason.${reason}`);
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch(`${state}/create`, { fileId: this.selectedFile._id, payload: this.form });
        await this.fetchFileAccessibleAccounts();
        this.resetForm();

        this.$toast.success(this.$t("common.success"));
        this.showNewAccessibleAccountPanel = false;
        this.$forceUpdate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async update(acl) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch(`${state}/update`, { fileId: this.selectedFile._id, payload: acl });

        await this.fetchFileAccessibleAccounts();
        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    resetForm() {
      this.form = { account: undefined, permissions: { read: false, edit: false, delete: false } };
    },
    onMemberSelect(item) {
      this.form = { ...this.form, account: item };
    },
    filterFunction(item) {
      const permissionFilter = new Set([
        "ORGANIZATION_ADMIN",
        "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        "ORGANIZATION_KVKK_ACCESS",
        "ORGANIZATION_GDPR_ACCESS",
        "ORGANIZATION_BGYS_ACCESS",
        "ORGANIZATION_DDO_ACCESS",
        "ORGANIZATION_BGYS_PRODUCT_ADMIN",
        "ORGANIZATION_DDO_PRODUCT_ADMIN",
        "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
        "ORGANIZATION_RISK_ADMIN",
        "ORGANIZATION_LEGAL_ADMIN",
      ]);

      const hasValidRole = item.accessable && item.roles?.some((role) => role.permissions?.some((permission) => permissionFilter.has(permission)));

      return item.isDepartmentAdmin || item.isProcessAdmin || item.isOwner || hasValidRole;
    },
    async deleteById(acl) {
      if (acl.editDisabled) {
        return;
      }
      const account = acl.account;
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/deleteByAccountId`, { fileId: this.selectedFile._id, accountId: account._id });
        await this.fetchFileAccessibleAccounts();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style scoped>
.add-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ff7c48;
  text-align: right;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
</style>
